export default "__VITE_ASSET__BdyBlwK0__"